export enum RootEquipmentStatus {
  Loading = -1,
  Running = 0,
  RunningAlarms = 1,
  StoppedNormal = 2,
  Trip = 3,
  NoDataConnection = 4,
  ConnectBasePackage = 5,
}

type RootEquipmentStatusData = {
  label: string;
  class: string;
  color: string;
};

export const ROOT_EQUIPMENT_STATUS_MAP = new Map<
  RootEquipmentStatus,
  RootEquipmentStatusData
>([
  [
    RootEquipmentStatus.Loading,
    { class: "circle-light-grey", label: "Loading", color: "#d7d7d7" },
  ],
  [
    RootEquipmentStatus.Running,
    { class: "circle-green", label: "Operational", color: "#0ca919" },
  ],
  [
    RootEquipmentStatus.RunningAlarms,
    {
      class: "circle-yellow",
      label: "Operational with Alerts",
      color: "#ffd800",
    },
  ],
  [
    RootEquipmentStatus.StoppedNormal,
    { class: "circle-violet", label: "Idle", color: "#cb2bd5" },
  ],
  [
    RootEquipmentStatus.Trip,
    { class: "circle-red", label: "Fault", color: "#f03040" },
  ],
  [
    RootEquipmentStatus.NoDataConnection,
    { class: "circle-grey", label: "No Data", color: "#a9a9a9" },
  ],
  [
    RootEquipmentStatus.ConnectBasePackage,
    {
      class: "",
      label: "Not Monitored",
      color: "#6764f6",
    },
  ],
]);
